import QuestYamlPage from '@playground/features/docs/QuestYamlPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/_superAdmin/docs/quest-yaml')({
  component: QuestYamlPage,
})
